// src/util/PublicRoute.js
import { Navigate, Outlet } from "react-router-dom";
import React from "react";
import { getAuthToken } from "./authToken";

const PublicRoute = () => {
  const token = getAuthToken();
  const isAuth = sessionStorage.getItem("isAuth");

  // Already authenticated? go straight to app
  if (token && isAuth) {
    return <Navigate to="/admin" replace />;
  }

  // Otherwise, render the intended public page
  return <Outlet />;
};

export default PublicRoute;
